import { createContext } from 'react';
import { BoxProps } from '@mui/material/Box';

interface TimelineContextValue {
  backgroundColor: string;
  leftContentProps?: BoxProps;
  lineColor: string;
}

export const TimelineContext = createContext<TimelineContextValue>({
  backgroundColor: 'transparent',
  lineColor: 'black',
});
